import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { GetSalesInvoicePaymentDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';
import momencik from '../../../common/momencik';
import numberFormatter from '../../../common/numberFormatter';

interface SalesInvoicePaymentsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
}

export const salesInvoicePaymentForGrid = (
  payment: GetSalesInvoicePaymentDto,
): GridRecord => ({
  key: payment.pokId,
  values: {
    'payment.invoiceNumber': payment.invoiceNumber,
    'payment.paymentType': payment.paymentType,
    'payment.amount': numberFormatter(payment.amount, true, undefined),
    'payment.paymentDate': payment.paymentDate
      ? momencik(payment.paymentDate)
      : '',
    'payment.currentInvoiceBalance':
      payment.currentInvoiceBalance !== null &&
      payment.currentInvoiceBalance !== undefined
        ? numberFormatter(payment.currentInvoiceBalance, true, undefined)
        : '',
    'payment.correctionInvoiceNumber': payment.correctionInvoiceNumber ?? '',
    'payment.correctionIssueDate': payment.correctionIssueDate
      ? momencik(payment.correctionIssueDate)
      : '',
  },
});

export const SalesInvoicePaymentsSearch: React.FC<
  SalesInvoicePaymentsSearchProps
> = props => {
  const { t, tk } = useTranslation('fvsLng');

  const columns: GridColumn[] = [
    {
      header: t(tk.finance.paymentAmount),
      property: 'payment.amount',
      noSorting: true,
    },
    {
      header: t(tk.finance.paymentType),
      property: 'payment.paymentType',
    },
    {
      header: t(tk.finance.paymentReceivedDate),
      property: 'payment.paymentDate',
    },
    {
      header: t(tk.finance.currentBalance),
      property: 'payment.currentInvoiceBalance',
      noSorting: true,
    },
    {
      header: t(tk.finance.correctedInvoiceNumber),
      property: 'payment.correctionInvoiceNumber',
    },
    {
      header: t(tk.finance.correctionDate),
      property: 'payment.correctionIssueDate',
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="payment.paymentDate"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.finance.paymentsList)}
      refresh={props.refresh}
      withHistory={false}
    />
  );
};
